export const sizes = {
  default: 600,
  large: 800,
  small: 400,
}
